import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { CaseTypesListComponent } from "./case_types/case-types-list/case-types-list.component";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { SharedModule } from "app/_shared/shared.module";
import { ManagementRoutingModule } from "./management-routing.module";
import { LocationTypesListComponent } from "./location-types/location-types-list/location-types-list.component";
import { AddLocationTypesComponent } from "./location-types/add-location-types/add-location-types.component";
import { WindowModule } from "@progress/kendo-angular-dialog";
import { UploadModule } from "@progress/kendo-angular-upload";
import { UpdatePolicyControlComponent } from "./policy_control/update-policy-control/update-policy-control.component";
import { HelpPlansTypesListComponent } from "./help-plans-types/help-plans-types-list/help-plans-types-list.component";
import { TabBarComponent } from "app/_layouts/tab-bar/tab-bar.component";
import { DeleteCaseTypeComponent } from "./case_types/delete-case-type/delete-case-type.component";
import { DeleteLocationTypeComponent } from "./location-types/delete-location-type/delete-location-type.component";
import { CaseDetailsListComponent } from "./case-details/case-details-list/case-details-list.component";
import { DeletePolicyControlComponent } from './policy_control/delete-policy-control/delete-policy-control.component';
import { PolicyControlComponent } from './policy_control/policy-control-list/policy-control-list.component';
import { HelpPlanTypesOverviewComponent } from "./help-plans-types-overview/help-plans-types-overview.component";
import { MidOfficeDiagnoseListComponent } from "./MidOfficeDiagnoses/mid-office-diagnose-list/mid-office-diagnose-list.component";
import { AddMidOfficeDiagnoseComponent } from "./MidOfficeDiagnoses/add-mid-office-diagnose/add-mid-office-diagnose.component";
import { DeleteMidOfficeDiagnoseComponent } from "./MidOfficeDiagnoses/delete-mid-office-diagnose/delete-mid-office-diagnose.component";
import { IcdDiagnosesListComponent } from "./ICDdiagnose/icd-diagnoses-list/icd-diagnoses-list.component";
import { DeleteIcdDiagnoseComponent } from "./ICDdiagnose/delete-icd-diagnose/delete-icd-diagnose.component";
import { EditIcdDiagnoseComponent } from "./ICDdiagnose/edit-icd-diagnose/edit-icd-diagnose.component";
import { AddIcdDiagnoseComponent } from "./ICDdiagnose/add-icd-diagnose/add-icd-diagnose.component";
import { CaseTypeDetailsComponent } from './case_types/case-type-details/case-type-details.component';
import { CountriesListComponent } from './Countries/countries-list/countries-list.component';
import { UserAccountListComponent } from "./user-accounts/user-accounts-list/user-accounts-list.component";
import { CedFrameLayoutModule } from "ced-ng-library";
import { UserAccountDetailsComponent } from "./user-accounts/user-account-details/user-account-details.component";
import { RolesListComponent } from "./roles/role-list/roles-list.component";
import { RoleDetailsComponent } from "./roles/roleDetails/role-details.component";
import { TemplateListComponent } from './Templates/template-list/template-list.component';
import { TemplateDetailsComponent } from './Templates/template-details/template-details.component';
import { ActionTypeListComponent } from "./actionTypes/actionType-List/actionType-list.component";
import { ActionTypeDetailComponent } from "./actionTypes/actionType-details/actionType-details.component";
import { MessagesOverviewComponent } from "./messages-overview/messages-overview-list/messages-overview.component";
import { MessagesOverviewContentComponent } from "./messages-overview/messages-overview-content/messages-overview-content.component";
import { CedProductDetailsComponent } from './ced-products/ced-product-details/ced-product-details.component';
import { CedProductListComponent } from './ced-products/ced-product-list/ced-product-list.component';
import { WorkActivityOptionDetailsComponent } from "./workActivityOptions/work-activity-option-details/work-activity-option-details.component";
import { WorkActivityOptionsListComponent } from "./workActivityOptions/work-activity-options-list/work-activity-options-list.component";
import { ServicesComponent } from './services/services/services.component';
import { SalesServiceListComponent } from './services/sales-service-list/sales-service-list.component';
import { SaleServiceDetailsComponent } from './services/sale-service-details/sale-service-details.component';
import { PurshasesServiceListComponent } from './services/purshases-service-list/purshases-service-list.component';
import { PurshaseServiceDetailsComponent } from './services/purshase-service-details/purshase-service-details.component';
import { HelpPlansTypesOverviewContentComponent } from './help-plans-types-overview/help-plans-types-content/help-plans-types-overview-content/help-plans-types-overview-content.component';
import { ClaimsReserveTypesContentComponent } from './help-plans-types-overview/help-plans-types-content/claims-reserve-types-content/claims-reserve-types-content.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ManagementRoutingModule,
    WindowModule,
    TreeViewModule,
    UploadModule,
    CedFrameLayoutModule
  ],
  declarations: [
    CaseTypesListComponent,
    LocationTypesListComponent,
    AddLocationTypesComponent,
    PolicyControlComponent,
    UpdatePolicyControlComponent,
    HelpPlansTypesListComponent,
    CaseDetailsListComponent,
    TabBarComponent,
    DeleteCaseTypeComponent,
    DeleteLocationTypeComponent,
    DeletePolicyControlComponent,
    HelpPlanTypesOverviewComponent,
    MidOfficeDiagnoseListComponent,
    AddMidOfficeDiagnoseComponent,
    DeleteMidOfficeDiagnoseComponent,
    IcdDiagnosesListComponent,
    DeleteIcdDiagnoseComponent,
    EditIcdDiagnoseComponent,
    AddIcdDiagnoseComponent,
    CaseTypeDetailsComponent,
    CountriesListComponent,
    UserAccountListComponent,
    UserAccountDetailsComponent,
    RolesListComponent,
    RoleDetailsComponent,
    TemplateListComponent,
    TemplateDetailsComponent,
    ActionTypeListComponent,
    ActionTypeDetailComponent,
    MessagesOverviewComponent,
    MessagesOverviewContentComponent,
    CedProductDetailsComponent,
    CedProductListComponent,
    WorkActivityOptionsListComponent,
    WorkActivityOptionDetailsComponent,
    ServicesComponent,
    SalesServiceListComponent,
    SaleServiceDetailsComponent,
    PurshasesServiceListComponent,
    PurshaseServiceDetailsComponent,
    HelpPlansTypesOverviewContentComponent,
    ClaimsReserveTypesContentComponent
  ],
  entryComponents:[
    UserAccountDetailsComponent,
    RoleDetailsComponent,
    CedProductDetailsComponent,
    TemplateDetailsComponent,
    ActionTypeDetailComponent,
    MessagesOverviewContentComponent,
    WorkActivityOptionDetailsComponent,
    SaleServiceDetailsComponent,
    PurshaseServiceDetailsComponent
  ]
})
export class ManagementModule { }